/**
 * Created by olga on 12.12.2024
 */

const TutorialStep = function (options) {
    this.onStart = options.onStart;
    this.onFinish = options.onFinish;
    this.onCheckConditions = options.onCheckConditions;
};

TutorialStep.prototype.isFinished = function () {
    return this.finished;
};

TutorialStep.prototype.checkConditions = function (options) {
    return this.onCheckConditions && this.onCheckConditions.call(this, options);
};

TutorialStep.prototype.start = function () {
    if (this.onStart) {
        this.onStart.call(this);
    }
};

TutorialStep.prototype.finish = function () {
    if (this.finished) {
        if (cleverapps.config.debugMode) {
            throw "Double step execution";
        }
        return;
    }

    runCleaners(this);

    this.finished = true;

    if (this.onFinish) {
        this.onFinish.call(this);
    }
};
